import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';

export default function Unauthorized() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface px-4 py-10 text-center">
      <div className="max-w-md rounded-3xl border border-stroke bg-white p-10 shadow-lg">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-error/10 text-error">
          <Icon icon="lucide:shield-off" width="32" />
        </div>
        <h1 className="text-2xl font-semibold text-font-primary mb-4">Access denied</h1>
        <p className="text-sm text-font-secondary mb-6">
          You do not have permission to view this page. If you believe this is an error, contact your administrator.
        </p>
        <Link
          to="/admin/dashboard"
          className="inline-flex items-center justify-center rounded-full bg-primary px-5 py-3 text-sm font-semibold text-white hover:bg-primary/90 transition-colors"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
